import i18n from "../../../../Frontends/Common/utils/i18n.js";
export class MarsPeriodBlockingAdjustmentsService {
  constructor() {
    this.blockingAdjustments = [
      { text: i18n.global.t("yes"), value: true },
      { text: i18n.global.t("no"), value: false }
    ]
  }

  async getBlockingAdjustmentsStatuses() {
    return Promise.resolve({ data: { records: this.blockingAdjustments } })
  }

}
